<template>
  <svg
    width="216"
    height="162"
    viewBox="0 0 216 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1774_2384)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M199.279 125.167C201.047 122.903 202 120.496 202 118C202 104.745 175.137 94 142 94C111.689 94 86.6271 102.991 82.5733 114.669C35.1959 117.21 0 126.691 0 138C0 151.255 48.3532 162 108 162C167.647 162 216 151.255 216 138C216 133.28 209.869 128.878 199.279 125.167Z"
        fill="#E7E8E9"
      />
      <path d="M38 58H128.219L128 138H38V58Z" fill="#DBF0EB" />
      <path d="M128.219 58H178V138H128L128.219 58Z" fill="#BBE2DA" />
      <path d="M38 58L24 28H82.0803L97 58H38Z" fill="#2F6F61" />
      <path d="M178 58L192.219 28H142.219L128.219 58H178Z" fill="#DBF0EB" />
      <path d="M73 58H97V86H73V58Z" fill="#53B7A1" />
      <path
        d="M131.645 12.8189C131.962 12.3664 131.852 11.7429 131.399 11.4261C130.947 11.1093 130.324 11.2193 130.007 11.6717L119.682 26.4164C119.366 26.8688 119.476 27.4924 119.928 27.8092C120.38 28.1259 121.004 28.016 121.321 27.5636L131.645 12.8189Z"
        fill="#97D3C6"
      />
      <path
        d="M88.5735 12.8188C88.2567 12.3664 88.3667 11.7428 88.8191 11.4261C89.2715 11.1093 89.895 11.2192 90.2118 11.6716L100.536 26.4164C100.853 26.8688 100.743 27.4923 100.291 27.8091C99.8382 28.1259 99.2147 28.0159 98.8979 27.5635L88.5735 12.8188Z"
        fill="#97D3C6"
      />
      <path
        d="M109.109 1C109.109 0.447715 109.557 0 110.109 0C110.661 0 111.109 0.447715 111.109 1V27C111.109 27.5523 110.661 28 110.109 28C109.557 28 109.109 27.5523 109.109 27V1Z"
        fill="#97D3C6"
      />
    </g>
  </svg>
</template>
